export default __webpack_public_path__ + "static/media/rabbit40.9bd20627.gif";